import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageEmployeeProfileLayer from "../../../components/Admin/ManageEmployeeProfileLayer";

const ManageEmployeeProfile = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageEmployeeProfileLayer />
      </MasterLayout>
    </>
  );
};

export default ManageEmployeeProfile;